import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Aarthikreportnamuna11 = () => {
  const [reportType, setReportType] = useState('all');
  const [demandType, setDemandType] = useState('सफाई कर');
  const navigate = useNavigate();

  const handleSubmit = () => {
    console.log('Form submitted:', { reportType, demandType });
  };

  const handleReportTypeChange = (e) => {
    setReportType(e.target.value);
  };

  const handleDemandTypeChange = (e) => {
    setDemandType(e.target.value);
  };

  const handleMiscBill = () => {
    console.log('किरकोळ मागणी बिल clicked:', { reportType, demandType });
  };

  const handleBack = () => {
    navigate('/aarthikreport');
  };

  const demandTypes = [
    'सफाई कर',
    'पाणी बिल',
    'गाव दारोगा फी',
    'इमारत फी',
    'जमिनी विक्री फी',
    'अन्य मागणी'
  ];

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          
          {/* Header */}
          <div className="bg-[#267c77] text-white px-6 py-4 text-center">
            <h1 className="text-xl font-bold">नमुना 11</h1>
          </div>

          {/* Back Button */}
          <div className="px-6 py-4 bg-gray-50 border-b">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors duration-200"
            >
              ← Back
            </button>
          </div>

          {/* Form Content */}
          <div className="p-6">
            <div className="space-y-6">
              
              {/* Report Type Radio Buttons */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-40">
                  प्रकार:
                </label>
                <div className="flex items-center space-x-6">
                  {/* All Radio Button */}
                  <div className="flex items-center space-x-2">
                    <input
                      type="radio"
                      id="all"
                      name="reportType"
                      value="all"
                      checked={reportType === 'all'}
                      onChange={handleReportTypeChange}
                      className="w-4 h-4 text-[#267c77] focus:ring-[#267c77] border-gray-300"
                    />
                    <label htmlFor="all" className="text-gray-700">
                      सर्व
                    </label>
                  </div>

                  {/* Demand Type Radio Button */}
                  <div className="flex items-center space-x-2">
                    <input
                      type="radio"
                      id="demandType"
                      name="reportType"
                      value="demandType"
                      checked={reportType === 'demandType'}
                      onChange={handleReportTypeChange}
                      className="w-4 h-4 text-[#267c77] focus:ring-[#267c77] border-gray-300"
                    />
                    <label htmlFor="demandType" className="text-gray-700">
                      मागणी प्रकारानुसार
                    </label>
                  </div>
                </div>
              </div>

              {/* Demand Type Dropdown */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-40">
                  मागणी प्रकार :
                </label>
                <div className="relative flex-1">
                  <select
                    value={demandType}
                    onChange={handleDemandTypeChange}
                    disabled={reportType !== 'demandType'}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                  >
                    {demandTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

            </div>

            {/* Buttons */}
            <div className="mt-8 flex justify-center space-x-4">
              <button
                onClick={handleMiscBill}
                className="bg-green-600 text-white px-6 py-3 rounded-md font-medium hover:bg-green-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                किरकोळ मागणी बिल
              </button>
              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-6 py-3 rounded-md font-medium hover:bg-green-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                नमुना 11
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Aarthikreportnamuna11;